var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-box"}},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{staticClass:"page"},[_c('h1',[_vm._v(" "),_c('i',{staticClass:"fa fa-table"}),_vm._v(" Markdown(GFM) Cheat Sheet")]),_c('sheet-table')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }